import React from "react";
import ReactDOM from "react-dom/client";
import AppWrapper from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { i18nReady } from "./i18n.ts";
import * as Sentry from "@sentry/react";
import { applyAnalyticsConsent } from "./lib/analytics";
import { hasAnalyticsConsent } from "./lib/consent";

// Only report from a deployed environment - local dev has no DSN set, so no
// dev errors get reported.
const env = (import.meta as any).env;
if (env?.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.MODE,
  });
}
// Same rule: only with VITE_GA_MEASUREMENT_ID (set by the deploy workflow),
// and only once the visitor has opted in to analytics cookies.
applyAnalyticsConsent(hasAnalyticsConsent());

// After a deploy, a tab opened before it may ask for a screen chunk that has
// been replaced. Reload to pick up the new build instead of showing an error;
// at most once per 10 seconds, so a chunk that is truly missing cannot loop.
window.addEventListener("vite:preloadError", (event) => {
  try {
    const last = Number(sessionStorage.getItem("chunk-reload-at") || 0);
    if (Date.now() - last < 10_000) return;
    sessionStorage.setItem("chunk-reload-at", String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

// English needs no fetch; another saved language is loaded first so the
// first paint is not in the wrong language.
void i18nReady.finally(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
        <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
          <AppWrapper />
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
});
